import React, { useState, useEffect } from 'react';
import {
  Box, Card, CardHeader, CardContent, Divider, Stack, TextField, Button,
  Snackbar, Alert, CircularProgress,
} from '@mui/material';
import SaveRoundedIcon from '@mui/icons-material/SaveRounded';
import CampaignRoundedIcon from '@mui/icons-material/CampaignRounded';
import { getBearerToken, postBearerToken } from '../../utils/Apis';
import AppShell from '../../layouts/AppShell';

// Broadcast message shown to participants. GET messages / POST messages.
const A_messages = () => {
  const [hostmessage, sethostmessage] = useState('');
  const [loader, setloader] = useState(false);
  const [toast, setToast] = useState(null);
  const notify = (msg, severity = 'info') => setToast({ msg, severity });

  const fetchMessages = async () => {
    setloader(true);
    getBearerToken('messages').then((result) => {
      if (result.error === 0) sethostmessage(result?.data?.message || '');
      setloader(false);
    });
  };

  const submit = async () => {
    setloader(true);
    postBearerToken('messages', { message: hostmessage }).then((result) => {
      if (result.error === 0) notify('Message saved.', 'success');
      else notify('Something went wrong.', 'error');
      setloader(false);
    });
  };

  useEffect(() => { fetchMessages(); }, []);

  return (
    <AppShell title="Messages" breadcrumb={['Messages']}>
      <Box sx={{ maxWidth: 680 }}>
        <Card>
          <CardHeader
            avatar={<CampaignRoundedIcon color="primary" />}
            title="Broadcast message"
            subheader="This message scrolls across your participants' screens."
            titleTypographyProps={{ variant: 'h5' }}
          />
          <Divider />
          <CardContent sx={{ p: { xs: 2.5, sm: 3.5 } }}>
            <Stack spacing={3}>
              <TextField
                label="Message" value={hostmessage}
                onChange={(e) => sethostmessage(e.target.value)}
                multiline minRows={3} placeholder="Type a message for your participants…"
              />
              <Divider />
              <Stack direction="row" justifyContent="flex-end">
                <Button variant="contained" onClick={submit} disabled={loader}
                  startIcon={loader ? <CircularProgress size={18} color="inherit" /> : <SaveRoundedIcon />}>
                  {loader ? 'Saving…' : 'Save message'}
                </Button>
              </Stack>
            </Stack>
          </CardContent>
        </Card>
      </Box>

      <Snackbar open={!!toast} autoHideDuration={4000} onClose={() => setToast(null)} anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}>
        {toast ? <Alert severity={toast.severity} variant="filled" onClose={() => setToast(null)}>{toast.msg}</Alert> : undefined}
      </Snackbar>
    </AppShell>
  );
};

export default A_messages;
